
import { computed, defineComponent } from "vue";
import router from "./router";
import { useStore } from "./store";
import { unauthorized } from "common/src/utils/request";
import LoadingIndicator from "common/src/components/LoadingIndicator.vue";

export default defineComponent({
  components: {
    LoadingIndicator,
  },
  setup() {
    const hiddenSidebar = computed(() => !!router.currentRoute.value.meta.anonymous);
    const isError = computed(() => !!router.currentRoute.value.meta.errorPage);

    const store = useStore();

    const logout = () => {
      unauthorized();
      router.push({ name: "Login" });
    };

    return {
      hiddenSidebar,
      isError,
      store,
      logout,
    };
  },
});
